// extracted by mini-css-extract-plugin
export default {"result":"style_result__PYNsn"};